import { useState } from 'react';

const faqs = [
  {
    id: 1,
    question: '51黑料在线观看需要注册吗？',
    answer: '不需要注册。51黑料所有黑料视频和吃瓜视频内容均可免费在线观看，无需注册账号，打开即看，方便快捷。',
  },
  {
    id: 2,
    question: '51黑料网的视频画质如何？',
    answer: '51黑料网在线观看的所有视频均提供高清画质，采用先进的视频编码技术，确保在不同网络环境下都能获得清晰流畅的播放体验，不卡顿、不缓冲等待。',
  },
  {
    id: 3,
    question: '51黑料一区二区有什么区别？',
    answer: '一区主要涵盖明星八卦、娱乐圈动态等吃瓜内容；二区则侧重社会热点、网红翻车、综艺揭秘等多元视频资源。两个分区内容各有侧重，用户可根据兴趣自由切换浏览。',
  },
  {
    id: 4,
    question: '51黑料视频更新频率是怎样的？',
    answer: '平台每日实时更新超过500条视频内容，覆盖全网热点事件。无论是突发新闻还是深度吃瓜，51黑料都会第一时间为您呈现最新内容，确保您不错过任何精彩。',
  },
  {
    id: 5,
    question: '51黑料在线看支持哪些设备？',
    answer: '51黑料完美适配PC端、手机端和平板设备，网页响应式设计确保在各种屏幕尺寸下都能获得良好的浏览体验。关注微信公众号还可获取推送提醒。',
  },
  {
    id: 6,
    question: '如何向51黑料投稿或提供线索？',
    answer: '欢迎通过投稿邮箱 tougao@51heiliao.com 向我们提供独家线索或原创内容。我们会对每条投稿认真审核，优质内容将获得首页推荐展示机会。也可通过客服邮箱咨询相关问题。',
  },
];

export default function FaqSection() {
  const [openId, setOpenId] = useState<number | null>(1);

  const toggle = (id: number) => {
    setOpenId(openId === id ? null : id);
  };

  return (
    <section id="faq" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-3xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-bold font-heading text-foreground-950 mb-3">
            常见问题
          </h2>
          <p className="text-sm text-foreground-600 max-w-lg mx-auto">
            关于51黑料在线观看的常见疑问解答
          </p>
        </div>

        <div className="space-y-3">
          {faqs.map((faq) => (
            <div
              key={faq.id}
              className="bg-background-50 border border-background-200/70 rounded-xl overflow-hidden"
            >
              <button
                onClick={() => toggle(faq.id)}
                className="w-full flex items-center justify-between p-5 text-left cursor-pointer transition-colors hover:bg-background-100"
              >
                <h3 className="text-sm font-semibold text-foreground-900 pr-4">
                  {faq.question}
                </h3>
                <div
                  className={`w-6 h-6 rounded-full flex items-center justify-center flex-shrink-0 transition-all ${
                    openId === faq.id
                      ? 'bg-primary-500 text-background-50 rotate-45'
                      : 'bg-background-200 text-foreground-600'
                  }`}
                >
                  <i className="ri-add-line text-sm"></i>
                </div>
              </button>
              {openId === faq.id && (
                <div className="px-5 pb-5">
                  <p className="text-sm text-foreground-600 leading-relaxed">{faq.answer}</p>
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}